import { useMemo } from 'react'

export type UserRole = 'demo' | 'company_user' | 'company_admin' | 'super_admin'

interface User {
  id: string
  email: string
  name: string
  role: UserRole
  companyId?: string
}

export function useAuth() {
  const user = useMemo(() => {
    const userStr = localStorage.getItem('user')
    if (!userStr) {
      return null
    }

    try {
      const parsedUser = JSON.parse(userStr) as User
      return parsedUser
    } catch (error) {
      console.error('Failed to parse user data:', error)
      return null
    }
  }, []) // Empty dependency array - only read once on mount

  const isAdmin = useMemo(() => {
    return user?.role === 'company_admin' || user?.role === 'super_admin'
  }, [user])

  const isSuperAdmin = useMemo(() => {
    return user?.role === 'super_admin'
  }, [user])

  return {
    user,
    role: user?.role ?? null,
    isAdmin,
    isSuperAdmin,
    isAuthenticated: !!user,
  }
}
